const DATA_TRACKING_SHEET = 'Data Tracking Sheet'
const DATA_TRACKING_SHEET_TYPES = [DATA_TRACKING_SHEET, 'Progress Monitoring Data Sheet']
const HOVER_TITLE_MAX_LENGTH = 43

const PROGRESS_MONITORING_PREFIXES = [
  'Progress Monitoring Assessment Collection: ',
  'Progress Monitoring Assessment: ',
  'Progress Monitoring Assessments: ',
  'Progress Monitoring Collection: '
]

export type ResourceTileTitles = {
  isDataTrackingSheet: boolean
  footerTitle: string
  hoverTitle: string
  previewLabel: string
  titleWithSet: string
}

const setSuffix = (setNumber: number) => (setNumber > 0 ? ` - Set ${setNumber}` : '')

const titleBetweenFirstColons = (title: string) => {
  const [, betweenColons] = title.split(':')
  return betweenColons === undefined ? title : betweenColons.trim()
}

const truncateHoverTitle = (title: string) => {
  if (title.length <= HOVER_TITLE_MAX_LENGTH) {
    return title
  }
  return `${title.slice(0, HOVER_TITLE_MAX_LENGTH)}...`
}

export const withoutProgressMonitoringPrefix = (title: string) => {
  const prefix = PROGRESS_MONITORING_PREFIXES.find((candidate) => title.startsWith(candidate))
  return prefix ? title.slice(prefix.length) : title
}

export const tileTitles = (type: string, title: string, setNumber: number): ResourceTileTitles => {
  const suffix = setSuffix(setNumber)
  const unprefixedTitle = withoutProgressMonitoringPrefix(title)
  const titleWithSet = `${unprefixedTitle}${suffix}`

  if (DATA_TRACKING_SHEET_TYPES.includes(type)) {
    const hoverTitle = `${DATA_TRACKING_SHEET}${suffix}`
    return {
      isDataTrackingSheet: true,
      footerTitle: DATA_TRACKING_SHEET,
      hoverTitle,
      previewLabel: `${hoverTitle}: ${unprefixedTitle}`,
      titleWithSet
    }
  }

  const assessmentTitle = titleBetweenFirstColons(title)
  return {
    isDataTrackingSheet: false,
    footerTitle: assessmentTitle,
    hoverTitle: `${truncateHoverTitle(assessmentTitle)}${suffix}`,
    previewLabel: `${assessmentTitle}${suffix}`,
    titleWithSet
  }
}
